module.exports = __webpack_public_path__ + "static/media/apple-btn.2c4aaa28.png";